import { Divider, Paper, Stack } from '@mui/material'
import { Fragment } from 'react/jsx-runtime'
import {
  StudyTimepointContainerRequirementSchema,
  StudyTimepointContainerSubmissionSchema,
} from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import UpdateSubmissionStatusExams from './UpdateSubmissionStatusExams'

export default function UpdateSubmissionStatusExamsList({
  container_submission,
  container_requirement,
}: {
  container_submission: StudyTimepointContainerSubmissionSchema
  container_requirement: StudyTimepointContainerRequirementSchema
}) {
  return (
    <Paper
      sx={{
        borderRadius: SPACING.borderRadiusXxl,
        bgcolor: 'paper.main',
      }}
    >
      <Stack spacing={SPACING.examDetailsListSpacing}>
        {container_submission.exam_metadata.map((exam, index) => {
          return (
            <Fragment key={index}>
              {index !== 0 && <Divider />}
              <UpdateSubmissionStatusExams exam={exam} container_requirement={container_requirement} />
            </Fragment>
          )
        })}
      </Stack>
    </Paper>
  )
}
